jQuery(function ($) {

    var typesArray = [];
    var amountsArray = [];

    // Guard: deze code wordt globaal gebundeld; op pagina's zonder #form -> anders null-crash.
    var _accForm = document.getElementById("form");
    if (_accForm) {
        _accForm.addEventListener("submit", (event) => {
            var _accSubmit = document.getElementById("submitButton");
            if (_accSubmit) _accSubmit.disabled = true;
        });
    }

    function addItem() {

        console.log("no");

        var type = document.getElementById("type");
        var typeDescription = type.options[type.selectedIndex].text; // Get the selected type description
        var typeId = type.value;
        var amountInput = document.getElementById("amount");
        var amount = amountInput.value ? parseInt(amountInput.value) : 1;

        var table = document.getElementById("item-table").getElementsByTagName("tbody")[0];
        var rows = table.getElementsByTagName("tr");
        var existingIndex = typesArray.indexOf(typeId);

        // Check if exists. If not, add new. If it does, add amount.
        if (existingIndex !== -1) {
            amountsArray[existingIndex] += amount;
            rows[existingIndex].getElementsByTagName("td")[1].textContent = amountsArray[existingIndex];
        } else {
            var newRow = table.insertRow();
            var typeCell = newRow.insertCell(0);
            typeCell.textContent = typeDescription; // Display description instead of ID
            var amountCell = newRow.insertCell(1);
            amountCell.textContent = amount;
            typesArray.push(typeId);
            amountsArray.push(amount);
            var deleteCell = newRow.insertCell(2);
            var deleteButton = document.createElement("button");
            deleteButton.textContent = "";
            deleteButton.className = "btn btn-danger p-0";
            deleteButton.onclick = function () {
                deleteRow(newRow);
            };
            var trashIcon = document.createElement("i");
            trashIcon.className = "ti-trash btn text-light";
            deleteButton.appendChild(trashIcon); // Append the trash icon to the button

            deleteCell.appendChild(deleteButton);
            updateItemsData();
            amountInput.value = "";
        }
    }

    function deleteRow(row) {
        var index = row.rowIndex;
        row.parentNode.removeChild(row);
        typesArray.splice(index - 1, 1);
        amountsArray.splice(index - 1, 1);
        updateItemsData();
    }

    function updateItemsData() {
        var typesInput = document.getElementById("types-data");
        typesInput.value = JSON.stringify(typesArray);

        var amountsInput = document.getElementById("amounts-data");
        amountsInput.value = JSON.stringify(amountsArray);
    }

})
